import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { ProductLinksCards } from '@src/components/promoCards/layouts/OneThird/ProductLinks';

import '../links/links.scss';

/**
 * ## Links
 *
 * Link components visible products for users
 * @param {array} products - array of products users can view
 */
export const ProductLinks = (props) => {
    const {
        products,
    } = props;

    const agent360Products = products.filter((p) => p.platform === 'agent360' && p.product_line === 'Foremost Signature Agent360');
    const arsProducts = products.filter((p) => p.platform === 'ars');
    const foremost5Products = products.filter((p) => p.product_line === 'Foremost 5.0 Agent360');

    return (
        <>
            <Row>
                <Col>
                    <h3>Agent360<sup>®</sup></h3>
                    <h5>Signature</h5>
                </Col>
            </Row>
            <Row>
                {
                    agent360Products.map((product) => {
                        const {
                            name,
                            slug,
                            has_legacy,
                            is_new,
                            platform,
                        } = product;

                        return (
                            <ProductLinksCards
                                key={`links-${slug}`}
                                text={name}
                                link={slug}
                                platform={platform}
                                isNew={is_new}
                                hasLegacy={has_legacy}
                            />
                        );
                    })
                }
            </Row>
            {
                foremost5Products.length > 0 && (
                    <>
                        <Row className="mt-4">
                            <Col>
                                <h3>Agent360<sup>®</sup></h3>
                                <h5>Foremost 5.0</h5>
                            </Col>
                        </Row>
                        <Row>
                            {
                                foremost5Products.map((product) => {
                                    const {
                                        name,
                                        slug,
                                        platform,
                                    } = product;

                                    return (
                                        <ProductLinksCards
                                            key={`links-${slug}`}
                                            text={name}
                                            link={slug}
                                            platform={platform}
                                        />
                                    );
                                })
                            }
                        </Row>
                    </>
                )
            }
            <Row className="mt-4">
                <Col>
                    <h3>ARS</h3>
                    <h5>Signature</h5>
                </Col>
            </Row>
            <Row>

                {
                    arsProducts.map((product) => {
                        const {
                            name,
                            slug,
                            has_legacy,
                            is_new,
                            platform,
                        } = product;

                        return (
                            <ProductLinksCards
                                key={`links-${slug}`}
                                text={name}
                                link={slug}
                                platform={platform}
                                isNew={is_new}
                                hasLegacy={has_legacy}
                            />
                        );
                    })
                }
            </Row>
        </>
    );
};

ProductLinks.propTypes = {
    products: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        slug: PropTypes.string,
        has_legacy: PropTypes.bool,
        is_new: PropTypes.bool,
        platform: PropTypes.string,
    })),
};

export default ProductLinks;
